export default [
	//商户提现审批列表
	{
		path: '/saas/withdraw/audit',
		name: 'p_finance_saas_withdraw_audit',
		props: route => route.params,
		component: () => import('@/pages/finance/saas_withdraw_apply_list')
	},
	//商户提现审批列表
	{
		path: '/saas/account/list',
		name: 'p_finance_saas_account',
		props: route => route.params,
		component: () => import('@/pages/finance/saas_account_list')
	},
	//商户余额账户收支列表
	{
		path: '/saas/balance/account/record',
		name: 'p_finance_saas_balance_record',
		props: route => route.params,
		component: () => import('@/pages/finance/balance_account_record_list')
	},
	//商户积分账户收支列表
	{
		path: '/saas/points/account/record',
		name: 'p_finance_saas_points_record',
		props: route => route.params,
		component: () => import('@/pages/finance/points_account_record_list')
	},
	//商户保证金账户收支列表
	{
		path: '/saas/deposit/account/record',
		name: 'p_finance_saas_deposit_record',
		props: route => route.params,
		component: () => import('@/pages/finance/deposit_account_record_list')
	},
	//商户充值记录列表
	{
		path: '/saas/recharge/audit',
		name: 'p_finance_saas_recharge_audit',
		props: route => route.params,
		component: () => import('@/pages/finance/saas_recharge_list')
	},//订单列表（待核销、已核销数据）
	{
		path: '/platform/order/check',
		name: 'p_xiaohei_order_check',
		props: route => route.params,
		component: () => import('@/pages/finance/xiaohei_order_check_list')
	},
	{
		path: '/platform/allinpay/flow',
		name: 'p_xiaohei_balance_record',
		props: route => route.params,
		component: () => import('@/pages/finance/platform_allinpay_flow_list')
	},//通联订单核销
	{
		path: '/allinpay/order/check',
		name: 'p_allinpay_order_check',
		props: route => route.params,
		component: () => import('@/pages/finance/allinpay_order_check_list')
	},
	//平台积分账户
	{
		path: '/platform/points/account',
		name: 'p_xiaohei_points_record',
		props: route => route.params,
		component: () => import('@/pages/finance/platform_points_account_list')
	},
	//小黑平台-保证金账户流水列表
	{
		path: '/platform/deposit/account',
		name: 'p_xiaohei_deposit_record',
		props: route => route.params,
		component: () => import('@/pages/finance/xiaohei_deposit_record_list')
	},
	//平台其它账户
	{
		path: '/platform/other/account',
		name: 'p_xiaohei_other_record',
		props: route => route.params,
		component: () => import('@/pages/finance/platform_other_account_list')
	},
	//销售账单（待核销、已核销数据）
	{
		path: 'sale/bill',
		name: 'p_xiaohei_sale_bill',
		props: route => route.params,
		component: () => import('@/pages/finance/sale_bill_list')
	},//售后账单
	{
		path: '/aftersale/bill',
		name: 'p_xiaohei_after_sale_bill',
		props: route => route.params,
		component: () => import('@/pages/finance/after_sale_bill_list')
	},//小黑商城会员保证金提现申请
	{
		path: '/user/withdraw/audit',
		name: 'p_platform_user_withdraw',
		props: route => route.params,
		component: () => import('@/pages/finance/user_withdraw_apply_list')
	},
];